import {useState} from "react";
import {toast} from "react-toastify";

export default function SingleDropdownTree({data = [], onSelect, dropdownMode = true, activeData = {}}) {

    const [showDropDown, setShowDropDown] = useState(false);

    const collapseHandler = ({target}) => {
        const subListEl = target.parentNode.nextElementSibling;
        if (subListEl && subListEl.classList.contains("sub-list")) {
            if (subListEl.classList.contains("collapsed")) {
                subListEl.classList.remove("collapsed");
                target.classList.remove("collapsed-node");
            } else {
                subListEl.classList.add("collapsed");
                target.classList.add("collapsed-node");
            }
        } else {
            toast.warn("زیرمجموعه این دسته بندی خالیست")
        }
    }

    const selectHandler = (firstNode, secondNode) => {
        setShowDropDown(false);
        onSelect({firstNode, secondNode});
    }

    return (
        <>
            {
                dropdownMode ?
                    <div className="relative w-full">
                        <div
                            className={`w-screen h-screen fixed left-0 top-0 z-20 ${showDropDown ? "" : "hidden"}`}
                            onClick={() => setShowDropDown(false)}
                        />

                        <button
                            onClick={() => setShowDropDown(true)}
                            type="button"
                            className="w-full rounded-2xl bg-pol-light-7 p-3.5 border border-pol-gray-light-3 flex items-center justify-between text-pol-dark-800">
                            <p>{activeData.title || "انتخاب کنید"}</p>
                            <i className="icon-simple-arrow-left block -rotate-90 text-sm"/>
                        </button>
                        <div
                            className={`absolute z-20 flex flex-col w-full h-[18.125rem] bg-white rounded-2xl top-0 left-0 shadow-[0_0_9px_11px_rgba(142,130,180,0.06)] pr-4 pl-2 pt-4 pb-3.5 ${showDropDown ? "" : "hidden"}`}>

                            <div className="pb-4 border-b border-b-pol-light text-pol-light-brown font-semibold">
                                {activeData.title || "انتخاب کنید"}
                            </div>
                            <ul className="pol-single-dropdown-tree flex-grow overflow-y-auto pol-scroll mt-2.5 space-y-4 pr-2.5">
                                {data.map(firstNode => (
                                    <li key={firstNode.value}>
                                        <div
                                            className="text-pol-dark font-bold text-sm"
                                        >
                                            <button type="button" onClick={collapseHandler} className="collapsed-node">
                                                <i className="icon-simple-arrow-left text-xs ml-3.5 -rotate-90 inline-block pointer-events-none duration-200"/>
                                            </button>
                                            <button type="button" onClick={() => selectHandler(firstNode)}>
                                                <span className={`pointer-events-none ${activeData.firstNodeActive === firstNode.value ? "text-pol-blue" : ""}`}>{firstNode.label}</span>
                                            </button>
                                        </div>
                                        {
                                            firstNode.children.length ?
                                                <ul className="space-y-2 mt-2 pr-6 sub-list collapsed">
                                                    {
                                                        firstNode.children.map(secondNode => (
                                                            <li key={secondNode.value}>
                                                                <button
                                                                    onClick={() => selectHandler(firstNode, secondNode)}
                                                                    type="button"
                                                                    className={`text-sm font-semibold ${activeData.secondNodeActive === secondNode.value ? "text-pol-blue" : "text-pol-dark-800"}`}
                                                                >
                                                                    {secondNode.label}
                                                                </button>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                                : null
                                        }
                                    </li>
                                ))}
                            </ul>

                            {/*<div*/}
                            {/*    className="bg-white w-full h-9 top-[calc(100%-36px)] left-0 flex-center z-10 font-semibold text-pol-red pt-2.5 pl-2">*/}
                            {/*    <button type="button" className="flex items-center" onClick={unselectAllHandler}>*/}
                            {/*        <i className="icon-trash ml-2.5"/>*/}
                            {/*        <span className="">حذف فیلتر</span>*/}
                            {/*    </button>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    :
                    <ul className="pol-single-dropdown-tree flex-grow overflow-y-auto pol-scroll mt-2.5 space-y-3 pr-2.5">
                        {data.map(firstNode => (
                            <li key={firstNode.value}>
                                <div
                                    className="text-pol-dark-2 font-bold text-sm mb-4"
                                >
                                    <button type="button" onClick={collapseHandler} className="collapsed-node">
                                        <i className="icon-simple-arrow-left text-xs ml-3.5 -rotate-90 inline-block pointer-events-none duration-200"/>
                                    </button>
                                    <button type="button" onClick={() => selectHandler(firstNode)}>
                                        <span className={`pointer-events-none ${activeData.firstNodeActive === firstNode.value ? "text-pol-blue" : ""}`}>
                                            {firstNode.label}
                                        </span>
                                    </button>
                                </div>
                                {
                                    firstNode.children.length ?
                                        <ul className="space-y-2 mt-2 pr-6 sub-list collapsed">
                                            {
                                                firstNode.children.map(secondNode => (
                                                    <li key={secondNode.value}>
                                                        <button
                                                            onClick={() => selectHandler(firstNode, secondNode)}
                                                            type="button"
                                                            className={`text-pol-dark-800 text-sm font-semibold ${activeData.secondNodeActive === secondNode.value ? "text-pol-blue" : "text-pol-dark-800"}`}>
                                                            {secondNode.label}
                                                        </button>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                        : null
                                }
                            </li>
                        ))}
                    </ul>
            }
        </>
    )
}
